/**
 * Stock disponível de um produto da loja, à prova das variações reais da API.
 *
 * A API pública devolve `stock` em minúsculas E como string ("0"); partes do
 * frontend liam `STOCK` (maiúsculas, number). O resultado era duplo:
 * `product.STOCK ?? 1` dava 1 a produtos esgotados (a montra deixava
 * adicioná-los ao carrinho, que depois rebentava no checkout com «Stock
 * insuficiente»), e `stock === 0` nunca era true com "0" string.
 *
 * Esta função é o único sítio que interpreta o stock: aceita as duas chaves,
 * converte para número, e devolve Infinity para digitais (sem stock físico).
 */
export function stockDisponivel(p: unknown): number {
  const prod = p as Record<string, unknown> | null | undefined;
  const tipo = (prod?.TIPO ?? prod?.tipo) as string | undefined;
  if (tipo === 'DIGITAL') return Infinity;
  const raw = prod?.STOCK ?? prod?.stock;
  if (raw === null || raw === undefined || raw === '') return 0;
  const n = Number(raw);
  return Number.isFinite(n) ? Math.max(0, n) : 0;
}

export function estaEsgotado(p: unknown): boolean {
  return stockDisponivel(p) <= 0;
}
